var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepost2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.5L13.5 14.5M13.5 5.5L7.5 8.5M16.5 19C14.8431 19 13.5 17.6569 13.5 16C13.5 14.3431 14.8431 13 16.5 13C18.1569 13 19.5 14.3431 19.5 16C19.5 17.6569 18.1569 19 16.5 19ZM4.5 13C2.84315 13 1.5 11.6569 1.5 10C1.5 8.34315 2.84315 7 4.5 7C6.15685 7 7.5 8.34315 7.5 10C7.5 11.6569 6.15685 13 4.5 13ZM16.5 7C14.8431 7 13.5 5.65685 13.5 4C13.5 2.34315 14.8431 1 16.5 1C18.1569 1 19.5 2.34315 19.5 4C19.5 5.65685 18.1569 7 16.5 7Z",
    stroke: "#7D5A42",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepost2);
export default __webpack_public_path__ + "static/media/repost2.5a97905be11870d2e3cc78e5df11edf6.svg";
export { ForwardRef as ReactComponent };